import { Injectable } from '@angular/core';
import { LOCAL_STORAGE_KEYS, LocalStorageService } from './local-storage.service';
import { Router } from '@angular/router';
import { AuthLinksService } from './auth-links.service';
import { CONSULT_REDIRECT_AFTER_AUTH_ROUTES } from '../shared/constants';
@Injectable({
  providedIn: 'root'
})
export class NavigateAfterLoginService {
  public constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private authLinksService: AuthLinksService,
  ) { }

  public saveRouteAndAuth(afterAuthRoute: string): void {
    this.localStorageService.setItem({
      key: LOCAL_STORAGE_KEYS.REDIRECT_AFTER_LOGIN,
      value: encodeURIComponent(afterAuthRoute)
    });

    this.forceLogin(afterAuthRoute);
  }

  private forceLogin(afterAuthRoute: string) {
    if(CONSULT_REDIRECT_AFTER_AUTH_ROUTES.some(term => afterAuthRoute.includes(term))) {
      window.location.href = this.authLinksService.bcasConsultLoginUrl;
    } else {
      throw new Error('Unknown login user for route: ' + afterAuthRoute);
    }
  }

  public checkRedirectAndReloadIfExist(afterAuthRoute: string): void {
    if(afterAuthRoute) {
      this.router.navigateByUrl(afterAuthRoute);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.REDIRECT_AFTER_LOGIN);
    }
  }
}
